class TopJs {
  constructor(el, opt) {
    this.el = el;
    if (document.querySelector("." + this.el)) {
      this.event();
    }
    if (document.querySelector('.js-mv-swiper')) {
      this.mvSwiper('.js-mv-swiper');
    }
    if (document.querySelector('.js-top-recruit-bg')) {
      this.recruitSwiper();
    }
    if (document.querySelector('.js-top-header')) {
      this.headerAnimation('.js-top-header');
    }
    if (document.querySelector('.js-informationSwiper')) {
      this.informationSwiper('.js-informationSwiper');
    }
  }
  event() {
    this.fvAnimation();
    this.middleAnimation();
  }
  recruitSwiper() {
    if (window.matchMedia('(max-width: 768px)').matches) {
      new Swiper('.js-top-recruit-bg', {
        slidesPerView: 2,
        loop: true,
        speed: 15000,
        direction: 'vertical',
        autoplay: {
          delay: 0,
        }
      })
    } else {
      new Swiper('.js-top-recruit-bg', {
        slidesPerView: 2.2,
        loop: true,
        speed: 15000,
        autoplay: {
          delay: 0,
        }
      })
    }
  }
  headerAnimation(headerEle) {
    // const ele = document.querySelector(headerEle);
    // const logoEle = ele.querySelector('.js-top-header__logo');
    // const navEle = ele.querySelector('.js-top-header__nav');
    // gsap.to(logoEle, {
    //   scrollTrigger: {
    //     trigger: '.js-mv-swiper',
    //     start: 'bottom 100px',
    //     end: 'bottom top',
    //     onEnter: () => {
    //       logoEle.classList.remove('is-active');
    //       navEle.classList.remove('is-active');
    //     },
    //     onEnterBack: () => {
    //       logoEle.classList.add('is-active');
    //       navEle.classList.add('is-active');
    //     }
    //   }
    // })
  }
  informationSwiper(el) {
    if (window.matchMedia('(max-width: 768px)').matches) {
      new Swiper(el, {
        slidesPerView: 1.3,
        centeredSlides: true,
        loop: true,
      })
    }
  }
  fvAnimation() {

    $('body').css({
      'position': 'fixed',
      'top': '0',
    })

    let tl = gsap.timeline();

    tl.to('.js-loading', 0.1, {
      opacity: '1',
    });
    tl.from('.js-loading-txt', 1, {
      opacity: 0,
      ease: "power4.out",
      delay: 0.5,
    });

    tl.to('.js-loading-heartCenter', 0.8, {
      opacity: 0,
      width: '50rem'
    });

    tl.from('.js-loading-heart', 2, {
      opacity: 0,
      rotate: '-10deg',
      scale: '0.7',
      ease: "power4.out",  
    });

    tl.to('.js-loading-txt', 1, {
      color: '#000',
      onComplete: function() {
        $('body').css({'position': 'static'})
        $('.js-mv-hidden').animate({'opacity': '1'}, 800);
      }
    }, '-=1');
  }

  middleAnimation() {
    $('.js-middle-hidden').css({'display': 'none'});

    $('.js-moddle-txt').each(function() {
      const $this = $(this);
  
      // ノードを一つずつ処理
      $this.contents().each(function processNode() {
        if (this.nodeType === Node.TEXT_NODE) {
          // テキストノードの場合、一文字ずつ<span>で囲む
          const text = $(this).text();
          const wrappedText = text.split('').map(char => `<span>${char}</span>`).join('');
          $(this).replaceWith(wrappedText);
        } else if (this.nodeType === Node.ELEMENT_NODE) {
          // 子要素を再帰的に処理
          $(this).contents().each(processNode);
        }
      });
    });

    let flag = false;

    let trigger = ScrollTrigger.create({
      trigger: ".js-middle-trigger",
      start:"center-=10px center",
      onEnter: () => {
        if (!flag) {
          $('.js-loading').css({'display': 'none'});
          flag = true;
          trigger.kill(); // トリガーを削除
        }

        let tl = gsap.timeline();
    
        tl.to('.js-line', 5, {
          'stroke-dashoffset': 1500,
        });
    
        tl.from('.js-moddle-txt span', 0.3, {
          opacity: 0,
          duration: 0,
          stagger: 0.05,
          onStart: () => {
            $('.js-moddle-txt').css({'opacity': '1'});
          }
        }, '<');
    
        tl.to('.js-moddle-svg svg:last-of-type, .js-moddle-btn', 0.8, {
          opacity: 1,
          onComplete: function() {
            // $('.js-loading').css({'display': 'block'});
            $('.js-moddle-anime').css({'opacity': '0'});
            $('.js-middle-hidden').css({'display': 'block'});
            $('html, body').scrollTop($('.js-middle').offset().top);
    
            gsap.to('.js-moddle-svg', {
              scrollTrigger: {
                pin: true, //トリガー要素を固定する
                trigger: ".js-middle",
                start:"center center",
                end:"center+=12500px center",
                scrub: 1,
              }
            });
    
            gsap.to('.js-moddle-scale', {
              scale: 22,
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center center",
                end:"center+=4000px center",
                scrub: 1,
              }
            });
    
            gsap.to('.js-moddle-opacity', {
              opacity: 0,
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center center",
                end:"center+=4000px center",
                scrub: 1,
              }
            });
            
            gsap.to('.js-moddle-txt, .js-moddle-btn', {
              opacity: 0,
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=3500px center",
                end:"center+=4000px center",
                scrub: 1,
                onLeave : () => {
                  $('.js-moddle-bg').css({'pointer-events': 'none'});
                },
                onEnterBack : () => {
                  $('.js-moddle-bg').css({'pointer-events': 'auto'});
                }
              }
            });
    
            gsap.to('.js-seek-bar', {
              opacity: '1',
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=3500px center",
                end:"center+=4000px center",
                scrub: 1,
              }
            });
    
            gsap.to('.js-middle-elA', {
              opacity: 1,
              top: '50%',
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=4000px center",
                end:"center+=4500px center",
                scrub: 1,
              }
            });
    
            gsap.to('.js-middle-elA > div', {
              opacity: 0,
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=5500px center",
                end:"center+=6000px center",
                scrub: 1,
              }
            });
    
            gsap.to('.js-seek-bar .a', {
              height: '100%',
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=4000px center",
                end:"center+=6000px center",
                scrub: 1,
              }
            });

            gsap.to('.js-middle-imgA', {
              scale: '1.1',
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=4000px center",
                end:"center+=6000px center",
                scrub: 1,
                onLeave : () => {
                  $('.js-middle-imgB').animate({'height': '100%'}, 800);
                  $('.js-seek-bar .a').animate({'opacity': '0'}, 800);
                  $('.js-middle-elA').css({'pointer-events': 'none'});
                  $('.js-middle-elB').css({'pointer-events': 'auto'});
                },
                onEnterBack : () => {
                  $('.js-middle-imgB').animate({'height': '0%'}, 800);
                  $('.js-seek-bar .a').animate({'opacity': '1'}, 800);
                  $('.js-middle-elA').css({'pointer-events': 'auto'});
                  $('.js-middle-elB').css({'pointer-events': 'none'});
                }
              }
            });
    
            gsap.to('.js-middle-elB', {
              opacity: 1,
              top: '50%',
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=7000px center",
                end:"center+=7500px center",
                scrub: 1,
              }
            });
    
            gsap.to('.js-middle-elB > div', {
              opacity: 0,
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=8500px center",
                end:"center+=9000px center",
                scrub: 1,
              }
            });
    
            gsap.to('.js-seek-bar .b', {
              height: '100%',
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=7000px center",
                end:"center+=9000px center",
                scrub: 1,
              }
            });

            gsap.to('.js-middle-imgB', {
              scale: '1.1',
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=7000px center",
                end:"center+=9000px center",
                scrub: 1,
                onLeave : () => {
                  $('.js-middle-imgC').animate({'height': '100%'}, 800);
                  $('.js-seek-bar .b').animate({'opacity': '0'}, 800);
                  $('.js-middle-elB').css({'pointer-events': 'none'});
                  $('.js-middle-elC').css({'pointer-events': 'auto'});
                },
                onEnterBack : () => {
                  $('.js-middle-imgC').animate({'height': '0%'}, 800);
                  $('.js-seek-bar .b').animate({'opacity': '1'} , 800);
                  $('.js-middle-elB').css({'pointer-events': 'auto'});
                  $('.js-middle-elC').css({'pointer-events': 'none'});
                }
              }
            });
    
            gsap.to('.js-middle-elC', {
              opacity: 1,
              top: '50%',
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=10000px center",
                end:"center+=10500px center",
                scrub: 1,
              }
            });
    
            gsap.to('.js-seek-bar .c', {
              height: '100%',
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=10000px center",
                end:"center+=12000px center",
                scrub: 1,
              }
            });

            gsap.to('.js-middle-imgC', {
              scale: '1.1',
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=10000px center",
                end:"center+=12000px center",
                scrub: 1,
              }
            });
          }
        });
      }
    })
    
  }
}
